import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { IconButton, Popover } from '@material-ui/core';
import Constant from '@/common/constant/Constant';
import SDeskTooltip from '@/component/common/SDeskTooltip';

export default function ExpandHeaderChatbox({
    isModePreview,
    chatbotSettings,
    setIsShowChatBox,
    isMaximizedPanel,
    setIsMaximizedPanel,
    isIframeChatBot,
    setIsShowModalEndChat,
    isActivateLiveChat,
    setIsNewUnReaMessage,
    getMessage
}) {
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);

    const [headerChatBotSetting, setHeaderChatBotSetting] = useState({});
    const [openSettingMenu, setOpenSettingMenu] = useState(null);
    const handleClose = () => {
        setOpenSettingMenu(null);
    };

    const onClickViewSetting = event => {
        setOpenSettingMenu(event.currentTarget);
    };

    const onClickZoomIn = async () => {
        window.parent.postMessage(Constant.CHATBOT_ACTION.ZOOMOUT_CHATBOT, '*');
        setIsMaximizedPanel(false);
        setOpenSettingMenu(null);
    };

    const onClickZoomOut = async () => {
        window.parent.postMessage(Constant.CHATBOT_ACTION.ZOOMIN_CHATBOT, '*');
        setIsMaximizedPanel(true);
        setOpenSettingMenu(null);
    };

    const onClickEndChat = async () => {
        setOpenSettingMenu(null);
        setIsShowModalEndChat(true);
    };

    useEffect(() => {
        if (!isModePreview) {
            setHeaderChatBotSetting(chatbotSettings);
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (headerChatBotSetting?.headersColor !== previewSetting?.headersColor) {
                setHeaderChatBotSetting(previewChatBotSetting => ({
                    ...previewChatBotSetting,
                    headersColor: previewSetting?.headersColor
                }));
            }      
            if (headerChatBotSetting?.headerIcon !== previewSetting?.headerIcon) {
                setHeaderChatBotSetting(previewChatBotSetting => ({
                    ...previewChatBotSetting,
                    headerIcon: previewSetting?.headerIcon
                }));
            } 

            if (headerChatBotSetting?.logo !== previewSetting?.logo) {
                setHeaderChatBotSetting(previewChatBotSetting => ({
                    ...previewChatBotSetting,
                    logo: previewSetting?.logo
                }));
            }
            if (headerChatBotSetting?.chatbotTextInHeader !== previewSetting?.chatbotTextInHeader) {
                setHeaderChatBotSetting(previewChatBotSetting => ({
                    ...previewChatBotSetting,
                    chatbotTextInHeader: previewSetting?.chatbotTextInHeader
                }));
            }
        }
    }, [previewSetting]);

    const isDisplayIconSeemore = () => {
        if (isModePreview || (!isDisplayIconEndLiveChat() && !isDisplayIconZoomChatBot())) {
            return false;
        }

        return true;
    }

    const isDisplayIconEndLiveChat = () => {
        if (isActivateLiveChat) {
            return true;
        }

        return false;
    }

    const isDisplayIconZoomChatBot = () => {
        // if (isIframeChatBot) {
        //     return true;
        // }

        // if (!isIframeChatBot && window.innerWidth > 1024) {
        //     return true;
        // }

        // return false;

        if (window.screen.width > 1024) {
            return true;
        }

        return false;

    }
    return (
        <div
            className={isIframeChatBot ? 'iframeChatbot chat-header' : 'chat-header'}
        >
            <div className="chat-logo">
                <img
                    src={
                        (headerChatBotSetting?.headerIcon &&
                            headerChatBotSetting?.headerIcon !== Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT) ?
                            headerChatBotSetting?.headerIcon : Constant.SETTING_CHAT_BOT.LOGO_ICON_WHITE
                    }
                    alt="Logo"
                />
            </div>
            <SDeskTooltip
                value={headerChatBotSetting?.chatbotTextInHeader}
                className="chat-title"
            />
            {isDisplayIconSeemore() && (
                <>
                    <div
                        className={`navTabs-item button-see-more mx-3 text-lg text-slate-400 ${
                            !isIframeChatBot ? 'displayBlock' : ''
                        }`}
                        onClick={onClickViewSetting}
                        style={{cursor: 'pointer'}}
                    >
                        <span>⋮</span>
                    </div>
                    {/* <IconButton
                        className={`navTabs-item button-see-more ${
                            !isIframeChatBot ? 'displayBlock' : ''
                        }`}
                        onClick={onClickViewSetting}
                    >
                        <img src="/assets/image/icon-nav-tabs.svg" alt="" />
                    </IconButton> */}
                    <Popover
                        className="navTabs-dropMenu"
                        id={'simple-popover'}
                        open={Boolean(openSettingMenu)}
                        anchorEl={openSettingMenu}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                    >
                        <ul>
                            {isDisplayIconZoomChatBot() && isMaximizedPanel && (
                                <li onClick={onClickZoomIn} className="button-zoom-in">
                                    <span className="navTabs-item">
                                        <img src="/assets/image/zoom-in.svg" alt="" />
                                    </span>
                                    <span className="navTabs-text">{getMessage('CBOTLB011')}</span>
                                </li>
                            )}
                            {isDisplayIconZoomChatBot() && !isMaximizedPanel && (
                                <li onClick={onClickZoomOut} className="button-zoom-in">
                                    <span className="navTabs-item">
                                        <img src="/assets/image/zoom-out.svg" alt="" />
                                    </span>
                                    <span className="navTabs-text">{getMessage('CBOTLB010')}</span>
                                </li>
                            )}
                            {isDisplayIconEndLiveChat() && (
                                <li onClick={onClickEndChat}>
                                    <span className="navTabs-item">
                                        <img src="/assets/image/end-chat.svg" alt="" />
                                    </span>
                                    <span className="navTabs-text">{getMessage('CBOTLB012')}</span>
                                </li>
                            )}
                        </ul>
                    </Popover>
                </>
            )}
            {!isModePreview && (
                <>
                    <div
                        className="navTabs-item close-chatbot mx-3 text-xl text-slate-400"
                        onClick={() => {
                            window.parent.postMessage(Constant.CHATBOT_ACTION.CLOSE_CHATBOT, '*');
                            setIsShowChatBox(false);
                            setIsNewUnReaMessage(false);
                        }}
                        style={{cursor: "pointer"}}
                    >
                        <span>x</span>
                    </div>
                </>
                // <IconButton
                //     className="navTabs-item"
                //     onClick={() => {
                //         window.parent.postMessage(Constant.CHATBOT_ACTION.CLOSE_CHATBOT, '*');
                //         setIsShowChatBox(false);
                //         setIsNewUnReaMessage(false);
                //     }}
                // >
                //     <img src="/assets/image/icon-close-panel.svg" alt="" />
                // </IconButton>
            )}
        </div>
    );
}
